import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function FooterSection() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-[#060b14] text-slate-500 py-12 border-t border-slate-800" data-id="element-1">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-2">
          <div className="flex justify-center space-x-6 mb-8 text-sm" data-id="element-3">
            <button onClick={() => setShowTerms(true)} className="hover:text-[#00d4ff] transition-colors cursor-pointer" data-id="element-4">
              Términos y Condiciones
            </button>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-[#00d4ff] transition-colors cursor-pointer" data-id="element-5">
              Política de Privacidad
            </button>
          </div>
          <p className="text-xs leading-relaxed max-w-2xl mx-auto text-slate-600" data-id="element-6">
            Descargo de responsabilidad: Los resultados pueden variar de una
            persona a otra. Este producto no sustituye el asesoramiento médico
            profesional. Consulte a su médico antes de comenzar cualquier
            programa de ejercicios o nutrición.
          </p>
          <p className="mt-6 text-xs text-slate-700" data-id="element-7">
            &copy; {new Date().getFullYear()} Plan B: Cuerpo 4.0. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-8">
          <div className="bg-[#0d1529] border border-slate-700 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-9">
            <div className="flex items-center justify-between p-6 border-b border-slate-700 sticky top-0 bg-[#0d1529]" data-id="element-10">
              <h2 className="font-heading text-xl font-bold text-white uppercase tracking-wide" data-id="element-11">
                Términos y Condiciones
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-700" data-id="element-12">
                <XIcon className="w-5 h-5" data-id="element-13" />
              </button>
            </div>
            <div className="p-6 space-y-6 text-slate-300 text-sm leading-relaxed" data-id="element-14">
              <div data-id="element-15">
                <h3 className="text-white font-semibold mb-2" data-id="element-16">
                  1. Aceptación de los Términos
                </h3>
                <p data-id="element-17">
                  Al adquirir y/o utilizar el producto digital "Plan B: Cuerpo
                  4.0", usted acepta quedar vinculado por estos Términos y
                  Condiciones. Si no está de acuerdo con alguno de estos
                  términos, le pedimos que no realice la compra.
                </p>
              </div>
              <div data-id="element-18">
                <h3 className="text-white font-semibold mb-2" data-id="element-19">
                  2. Descripción del Producto
                </h3>
                <p data-id="element-20">
                  "Plan B: Cuerpo 4.0" es un programa de bienestar digital que
                  incluye guías, protocolos y materiales informativos en formato
                  digital. El acceso se otorga de forma inmediata tras la
                  confirmación del pago.
                </p>
              </div>
              <div data-id="element-21">
                <h3 className="text-white font-semibold mb-2" data-id="element-22">
                  3. Uso Personal
                </h3>
                <p data-id="element-23">
                  El contenido adquirido es para uso personal y no comercial.
                  Queda prohibida la reproducción, distribución, venta o cesión
                  del material a terceros sin autorización expresa por escrito.
                </p>
              </div>
              <div data-id="element-24">
                <h3 className="text-white font-semibold mb-2" data-id="element-25">
                  4. Política de Reembolso
                </h3>
                <p data-id="element-26">
                  Dado que se trata de un producto digital con acceso inmediato,
                  no se ofrecen reembolsos una vez que el acceso ha sido
                  entregado, salvo que la legislación aplicable en su país lo
                  exija expresamente.
                </p>
              </div>
              <div data-id="element-27">
                <h3 className="text-white font-semibold mb-2" data-id="element-28">
                  5. Descargo de Responsabilidad Médica
                </h3>
                <p data-id="element-29">
                  El contenido de este programa es únicamente informativo y
                  educativo. No constituye asesoramiento médico, diagnóstico ni
                  tratamiento. Consulte siempre a un profesional de la salud
                  antes de iniciar cualquier programa de nutrición o ejercicio.
                </p>
              </div>
              <div data-id="element-30">
                <h3 className="text-white font-semibold mb-2" data-id="element-31">6. Resultados</h3>
                <p data-id="element-32">
                  Los resultados individuales pueden variar. Los testimonios y
                  ejemplos presentados no garantizan que usted obtendrá los
                  mismos resultados. El éxito depende de factores individuales
                  como dedicación, condición física y seguimiento del programa.
                </p>
              </div>
              <div data-id="element-33">
                <h3 className="text-white font-semibold mb-2" data-id="element-34">
                  7. Propiedad Intelectual
                </h3>
                <p data-id="element-35">
                  Todo el contenido, incluyendo textos, imágenes, gráficos y
                  materiales del programa, es propiedad exclusiva de Plan B:
                  Cuerpo 4.0 y está protegido por las leyes de propiedad
                  intelectual aplicables.
                </p>
              </div>
              <div data-id="element-36">
                <h3 className="text-white font-semibold mb-2" data-id="element-37">
                  8. Modificaciones
                </h3>
                <p data-id="element-38">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Las modificaciones entrarán en vigor desde
                  su publicación. El uso continuado del producto implica la
                  aceptación de los términos actualizados.
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-slate-700" data-id="element-39">
              <button onClick={() => setShowTerms(false)} className="w-full bg-[#00d4ff] hover:bg-[#0099cc] text-[#0a0f1e] font-bold py-3 rounded-xl transition-colors duration-200" data-id="element-40">
                Entendido
              </button>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-41">
          <div className="bg-[#0d1529] border border-slate-700 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-42">
            <div className="flex items-center justify-between p-6 border-b border-slate-700 sticky top-0 bg-[#0d1529]" data-id="element-43">
              <h2 className="font-heading text-xl font-bold text-white uppercase tracking-wide" data-id="element-44">
                Política de Privacidad
              </h2>
              <button onClick={() => setShowPrivacy(false)} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-700" data-id="element-45">
                <XIcon className="w-5 h-5" data-id="element-46" />
              </button>
            </div>
            <div className="p-6 space-y-6 text-slate-300 text-sm leading-relaxed" data-id="element-47">
              <div data-id="element-48">
                <h3 className="text-white font-semibold mb-2" data-id="element-49">
                  1. Información que Recopilamos
                </h3>
                <p data-id="element-50">
                  Recopilamos información personal que usted nos proporciona
                  voluntariamente al realizar una compra, incluyendo nombre,
                  dirección de correo electrónico y datos de pago procesados de
                  forma segura por nuestros proveedores de pago.
                </p>
              </div>
              <div data-id="element-51">
                <h3 className="text-white font-semibold mb-2" data-id="element-52">
                  2. Uso de la Información
                </h3>
                <p data-id="element-53">
                  Utilizamos su información exclusivamente para procesar su
                  compra, entregar el acceso al producto digital adquirido y
                  enviarle comunicaciones relacionadas con su pedido. No
                  vendemos ni compartimos sus datos con terceros con fines
                  comerciales.
                </p>
              </div>
              <div data-id="element-54">
                <h3 className="text-white font-semibold mb-2" data-id="element-55">
                  3. Seguridad de los Datos
                </h3>
                <p data-id="element-56">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger su información personal contra accesos no
                  autorizados, pérdida o divulgación. Los pagos son procesados
                  mediante plataformas certificadas con cifrado SSL.
                </p>
              </div>
              <div data-id="element-57">
                <h3 className="text-white font-semibold mb-2" data-id="element-58">4. Cookies</h3>
                <p data-id="element-59">
                  Nuestro sitio puede utilizar cookies para mejorar la
                  experiencia de navegación y analizar el tráfico. Puede
                  configurar su navegador para rechazar cookies, aunque esto
                  podría afectar la funcionalidad del sitio.
                </p>
              </div>
              <div data-id="element-60">
                <h3 className="text-white font-semibold mb-2" data-id="element-61">
                  5. Comunicaciones por Correo Electrónico
                </h3>
                <p data-id="element-62">
                  Al realizar una compra, usted acepta recibir correos
                  electrónicos relacionados con su pedido y, ocasionalmente,
                  comunicaciones sobre productos y contenido relevante. Puede
                  darse de baja en cualquier momento mediante el enlace incluido
                  en cada correo.
                </p>
              </div>
              <div data-id="element-63">
                <h3 className="text-white font-semibold mb-2" data-id="element-64">
                  6. Retención de Datos
                </h3>
                <p data-id="element-65">
                  Conservamos sus datos personales durante el tiempo necesario
                  para cumplir con los fines descritos en esta política y con
                  las obligaciones legales aplicables.
                </p>
              </div>
              <div data-id="element-66">
                <h3 className="text-white font-semibold mb-2" data-id="element-67">
                  7. Sus Derechos
                </h3>
                <p data-id="element-68">
                  Usted tiene derecho a acceder, rectificar o solicitar la
                  eliminación de sus datos personales. Para ejercer estos
                  derechos, puede comunicarse con nosotros a través de los
                  canales disponibles en este sitio.
                </p>
              </div>
              <div data-id="element-69">
                <h3 className="text-white font-semibold mb-2" data-id="element-70">
                  8. Cambios en la Política
                </h3>
                <p data-id="element-71">
                  Nos reservamos el derecho de actualizar esta Política de
                  Privacidad en cualquier momento. Le notificaremos sobre
                  cambios significativos publicando la nueva versión en este
                  sitio con la fecha de actualización correspondiente.
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-slate-700" data-id="element-72">
              <button onClick={() => setShowPrivacy(false)} className="w-full bg-[#00d4ff] hover:bg-[#0099cc] text-[#0a0f1e] font-bold py-3 rounded-xl transition-colors duration-200" data-id="element-73">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}